<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Single selection</h6>
            </div>
          </header>
          <div class="vs-card--content text-center con-select-example">
            <vs-select class="selectExample" label="Figuras" v-model="select1">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options1"
              />
            </vs-select>
            <vs-select class="selectExample" label="Figuras" v-model="select2">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options2"
              />
            </vs-select>
            <vs-select
              disabled
              class="selectExample"
              label="Figuras"
              v-model="select3"
            >
              <vs-select-item
                :key="index"
                :disabled="index == 2"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options3"
              />
            </vs-select>
            <vs-select
              class="selectExample"
              label="Figuras"
              v-model="select4"
              icon="arrow_downward"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options4"
              />
            </vs-select>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Color</h6>
            </div>
          </header>
          <div class="vs-card--content con-select-example">
            <input v-model="colorx" type="color" name="" value="" />
            <vs-select
              :color="colorx"
              class="selectExample"
              label="Figuras"
              v-model="select1"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options1"
              />
            </vs-select>
            <vs-select
              :color="select2c"
              class="selectExample"
              label="Figuras"
              v-model="select2"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in colors"
              />
            </vs-select>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Autocomplete</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-select
              autocomplete
              @input-change="autoCompleteFunc"
              class="w-full mb-2"
              label="Figuras"
              v-model="select1"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options1"
              />
            </vs-select>
            <vs-select
              autocomplete
              @input-change="autoCompleteFunc"
              class="w-full mb-2"
              label="Figuras"
              v-model="select2"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options2"
              />
            </vs-select>
            <vs-select
              autocomplete
              @input-change="autoCompleteFunc"
              disabled="true"
              class="w-full"
              label="Figuras"
              v-model="select3"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options3"
              />
            </vs-select>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Multiple</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-select
              placeholder="Multiple"
              multiple
              class="w-full mb-2"
              label="Figuras"
              v-model="select1m"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options1"
              />
            </vs-select>
            <vs-select
              placeholder="Multiple and autocomplete"
              multiple
              autocomplete
              class="w-full mb-2"
              label="Figuras"
              v-model="select2m"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options2"
              />
            </vs-select>
            <vs-select
              placeholder="Max Selected"
              max-selected="2"
              multiple
              class="w-full"
              label="Figuras"
              v-model="select3m"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options3"
              />
            </vs-select>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Validators</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-select
              :success="true"
              success-text="This field is valid"
              placeholder="Select"
              class="w-full mb-2"
              label="Success"
              multiple
              v-model="select1v"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in exampleOptions"
              />
            </vs-select>
            <vs-select
              :danger="true"
              danger-text="This field is invalid"
              placeholder="Select"
              class="w-full mb-2"
              label="Danger"
              multiple
              v-model="select2v"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in exampleOptions"
              />
            </vs-select>
            <vs-select
              :warning="true"
              warning-text="This field is invalid"
              placeholder="Select"
              class="w-full mb-2"
              label="Warning"
              multiple
              v-model="select3v"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in exampleOptions"
              />
            </vs-select>
            <vs-select
              description-text="Simple info for multiple select"
              placeholder="Select"
              class="w-full"
              label="Description"
              multiple
              v-model="select4v"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in exampleOptions"
              />
            </vs-select>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
    autoCompleteFunc(event) {
      console.log(event);
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({
    colorx: "#103767",
    select1v: [],
    select2v: [],
    select3v: [],
    select4v: [],
    select1m: [],
    select2m: [],
    select3m: [],
    select1Normal: "",
    select1: 2,
    select2: 7,
    select2c: "primary",
    select3: 2,
    select4: 5,
    options1: [
      { text: "IT", value: 0 },
      { text: "Blade Runner", value: 2 },
      { text: "Thor Ragnarok", value: 3 },
    ],
    options2: [
      { text: "Square", value: 1 },
      { text: "Rectangle", value: 2 },
      { text: "Rombo", value: 3 },
      { text: "Romboid", value: 4 },
      { text: "Trapeze", value: 5 },
      { text: "Triangle", value: 6 },
      { text: "Polygon", value: 7 },
      { text: "Regular polygon", value: 8 },
      { text: "Circumference", value: 9 },
      { text: "Circle", value: 10 },
      { text: "Circular sector", value: 11 },
      { text: "Circular trapeze", value: 12 },
    ],
    options3: [
      { text: "Red", value: 1 },
      { text: "Green", value: 2 },
      { text: "Blue", value: 3 },
      { text: "Purple", value: 4 },
    ],
    options4: [
      { text: "Square", value: 1 },
      { text: "Rectangle", value: 2 },
      { text: "Rombo", value: 3 },
      { text: "Romboid", value: 4 },
      { text: "Trapeze", value: 5 },
      { text: "Triangle", value: 6 },
      { text: "Polygon", value: 7 },
    ],
    colors: [
      { text: "Primary", value: "primary" },
      { text: "Success", value: "success" },
      { text: "Danger", value: "danger" },
      { text: "Warning", value: "warning" },
      { text: "Dark", value: "dark" },
    ],
    exampleOptions: [
      { text: "Square", value: 1 },
      { text: "Rectangle", value: 2 },
      { text: "Rombo", value: 3 },
      { text: "Romboid", value: 4 },
      { text: "Trapeze", value: 5 },
      { text: "Triangle", value: 6 },
      { text: "Polygon", value: 7 },
      { text: "Regular polygon", value: 8 },
      { text: "Circumference", value: 9 },
      { text: "Circle", value: 10 },
      { text: "Circular sector", value: 11 },
      { text: "Circular trapeze", value: 12 },
    ],
  }),
};
</script>
